import { createVNode as n, mergeProps as f } from "vue";
import m from "../node_modules/@pf-ui/pf-icon-svg/es/asn/PdfTwoTone.js";
import s from "../components/PfIcon.js";
const o = (r, e) => {
  const t = {
    ...r,
    ...e.attrs
  };
  return n(s, f(t, {
    icon: m
  }), null);
};
o.displayName = "PdfTwoTone";
o.inheritAttrs = !1;
export {
  o as default
};
